import { useRoute } from "vue-router";

export function getStrUrlParam(param: string) {
  const route = useRoute();
  return typeof route.query[param] === "string" ||
    route.query[param] instanceof String
    ? (route.query[param] as string)
    : "";
}
